import { defineMessages } from 'react-intl';

export default defineMessages({
  NextLabel: {
    id: 'ApplicationStep.Next',
    defaultMessage: 'Next',
  },
  Progress: {
    id: 'ApplicationStep.Progress',
    defaultMessage: 'Step {current} of {total}',
  },
  PreviousLabel: {
    id: 'ApplicationStep.Previous',
    defaultMessage: 'Previous',
  },
  SubmitLabel: {
    id: 'ApplicationStep.Submit',
    defaultMessage: 'Submit',
  },
});
